__webpack_require__.p = "/corgi/assets/";